var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPackageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1166 12.5403C22.4691 12.1879 22.6671 11.7099 22.6672 11.2115C22.6673 10.7131 22.4693 10.2351 22.1169 9.88262C21.7646 9.53015 21.2866 9.33209 20.7882 9.33203C20.2898 9.33197 19.8117 9.5299 19.4593 9.88229L10.5619 18.7816C10.4072 18.936 10.2927 19.126 10.2286 19.335L9.34794 22.2363C9.33071 22.2939 9.32941 22.3552 9.34417 22.4135C9.35894 22.4719 9.38922 22.5251 9.4318 22.5676C9.47439 22.6101 9.52769 22.6403 9.58605 22.655C9.6444 22.6697 9.70565 22.6683 9.76327 22.651L12.6653 21.771C12.8741 21.7075 13.0641 21.5937 13.2186 21.4396L22.1166 12.5403Z",
    stroke: "#3A6164",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.332L20.6667 13.9987",
    stroke: "#3A6164",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPackageIcon);
export default __webpack_public_path__ + "static/media/edit_package_icon.fc70b7ca1db1b29e61c4fc6477120d1f.svg";
export { ForwardRef as ReactComponent };